var rtl = false;
if(document.dir == 'rtl')
  rtl = true;
$('.list-mostpopulare-link').click(function(){
    var val = $(this).text();
    $('.search-input [name="q"]').val(val);
    $('.search-input [name="q"]')[0].dispatchEvent(new Event('input', {
        bubbles: true,
        cancelable: true,
    }));
});
$('.mrk-location-option').click(function() {
    $('.mrk-location-option').removeClass('location-selected');
    $(this).addClass('location-selected');
    var value = $(this).attr('value');
    var innerText = $(this).text();
    $('.selected-location-time').text(value);
    $('.selected-location-name').text(innerText);
    document.querySelector('#city-select details summary').click()
});
if($('#city-select').length){
$(document).click(function(e) {
    if($('#city-select .accordion').attr('aria-expanded') == 'true'){
        if (!$(e.target).closest('#city-select').length) {
            document.querySelector('#city-select details summary').click()
        }
    }
});
}
function updateBodyClass() {
    $(".mrk-top-bar .facets-horizontal").bind("DOMSubtreeModified", function() {
        setTimeout(function(){
            if ($('.mrk-top-bar .facets-horizontal [aria-expanded="true"]').length) {
                $('body').addClass('expanded-element-active');
            } else {
                $('body').removeClass('expanded-element-active');
            }
        },100)
    });
}
initAllEvents();

$(document).on('mrk:filterLoaded',initAllEvents);
function initAllEvents(){
    $('[aria-controls="facet-drawer-sort"]').off('click');
    $('[aria-controls="facet-drawer-sort"]').click(function(){
        document.querySelector('facet-drawer-sort').show();
    });
    $('.mrk-close-icon').off('click');
    $('.mrk-close-icon').click(function(){
        $('.facets-horizontal').click()
    });
    $('.mrk-filter-item-container [is="facet-link"]').off('click');
    $('.mrk-filter-item-container [is="facet-link"]').click(function(){
        $('.facets-horizontal').click()
    });
    $('.mrk-top-bar .facets-drawer__floating-apply [type="reset"]').click(function (e) {
        var container = $(this).parents('facet-dialog');
        $('facet-dialog').find('input').prop('checked',false);
        $(container).find('[type="submit"]').click();
    });
    if($(".mrk-top-bar .facets-horizontal").length)
    updateBodyClass();
}
$(document).ready(function() {
    var scrollAmount = 100; // Adjust this value based on your requirement
    var animationSpeed = 200;
    // Function to check the state of the scroll and toggle the disabled attribute of buttons
    function checkScroll($container) {
        var $prevButton = $container.find('.mrk-prev-slider-btn button');
        var $nextButton = $container.find('.mrk-next-slider-btn button');

        if ($container.find('.variant-picker__option-values').scrollLeft() <= 0) {
            $prevButton.attr('disabled', true);
        } else {
            $prevButton.attr('disabled', false);
        }

        var widthOfContainer = $container.find('.variant-picker__option-values').innerWidth();
        var widthOfContent = $container.find('.variant-picker__option-values')[0].scrollWidth;

        if ($container.find('.variant-picker__option-values').scrollLeft() + widthOfContainer >= widthOfContent) {
            $nextButton.attr('disabled', true);
        } else {
            $nextButton.attr('disabled', false);
        }
    }

    // Initial check for each container
    $('.mrk-slider-container').each(function() {
        checkScroll($(this));
    });

    // Attach click event to Next button
    $('.mrk-next-slider-btn button').click(function() {
        var $container = $(this).closest('.mrk-slider-container');
        var $content = $container.find('.variant-picker__option-values');
        if(rtl){
        $content.animate({
            scrollLeft: '-=' + scrollAmount
        }, animationSpeed, function() {
            checkScroll($container);
        });
        }else{
          $content.animate({
              scrollLeft: '+=' + scrollAmount
          }, animationSpeed, function() {
              checkScroll($container);
          });
        }
    });

    // Attach click event to Previous button
    $('.mrk-prev-slider-btn button').click(function() {
        var $container = $(this).closest('.mrk-slider-container');
        var $content = $container.find('.variant-picker__option-values');
        if(rtl){
        $content.animate({
            scrollLeft: '+=' + scrollAmount
        }, animationSpeed, function() {
            checkScroll($container);
        });
        }else{
          $content.animate({
              scrollLeft: '-=' + scrollAmount
          }, animationSpeed, function() {
              checkScroll($container);
          });
        }
    });
});
// document.addEventListener('DOMContentLoaded', function() {
//   if (window.location.pathname.includes('/collections/vendors')) {
//     const urlParams = new URLSearchParams(window.location.search);
//     const vendorName = urlParams.get('q');
//     if (vendorName) {
//       const formattedVendorName = vendorName.toLowerCase().replace(/[^a-z0-9]+/g, '-');
//       window.location.href = `/collections/${formattedVendorName}`;
//     }
//   }
// });
// document.addEventListener('DOMContentLoaded', function() {
//   const path = window.location.pathname;
//   const vendorPathPattern = /^\/collections\/([^\/]+)$/;
//   const match = path.match(vendorPathPattern);
  
//   if (match) {
//     const vendorName = decodeURIComponent(match[1]).replace(/-/g, ' ');
//     const vendorCollectionHandle = 'vendor-products';
    
//     fetch(`/collections/${vendorCollectionHandle}?view=vendor&vendor=${encodeURIComponent(vendorName)}`)
//       .then(response => response.text())
//       .then(html => {
//         const parser = new DOMParser();
//         const doc = parser.parseFromString(html, 'text/html');
//         const vendorProductsSection = doc.querySelector('.vendor-products');

//         if (vendorProductsSection) {
//           document.documentElement.innerHTML = doc.documentElement.innerHTML;
//           document.title = `${vendorName.charAt(0).toUpperCase() + vendorName.slice(1)} Products`;
//         } else {
//           document.documentElement.innerHTML = '<p>No products found for vendor ' + vendorName + '.</p>';
//         }
//       });
//   }
// });